import React, {Component} from 'react';
import {Row, Col, Button, Alert } from 'antd';
import downloadImg from "../images/download.svg";
import SepaImg from "../images/Sepa.svg";
import fertigstellungImg from "../images/fertigstellungImg.svg";

class Success extends Component {


    render() {
        return (
           <div className={"container"}>
               <div className={"content"}>



                   <Row style={{textAlign: "center"}}>
                       {/*<Col style={{color: "#a9a9a9"}} span={6}>
                           <div style={{height: "155px"}}>
                               <img style={{width: "106px"}} src={finishImg}/>
                           </div>
                           <h2 style={{color: "#a9a9a9"}}>
                               1. Antrag gestellt
                           </h2>
                           <br/>
                               <Button disabled className={"pull-right"} type={"primary"} >Antrag stellen</Button>
                           <br/><br/>
                           <p>
                               Ihr Antrag wurde erfolgreich eingereicht.
                           </p>
                       </Col>*/}
                       <Col sm={8} xs={24} style={{padding: "15px"}}>
                           <div style={{height: "155px"}}>
                               <img style={{width: "106px"}} src={downloadImg}/>
                           </div>
                           <h2>
                              1. Hinweise herunterladen
                           </h2>
                           <br/>
                            <a href="https://www.rottenburger-gruppe.de/export/download.php?id=268">
                                <Button className={"pull-right"} type={"primary"} >Wichtige Hinweise herunterladen</Button>
                            </a>
                           <br/><br/>
                           <p>
                               Wichtige Hinweise für Sie zur Wasserinstallation.
                           </p>
                       </Col>
                       <Col span={8} style={{padding: "15px"}}>
                           <div style={{height: "155px"}}>
                                <img style={{width: "130px"}} src={SepaImg}/>
                           </div>
                           <h2>
                               2. SEPA
                           </h2>
                           <br/>
                           <a href="https://www.rottenburger-gruppe.de/export/download.php?id=23">
                               <Button className={"pull-right"} type={"primary"} >SEPA Formular herunterladen</Button>
                           </a>
                           <br/><br/>
                           <p>
                               SEPA Formular ausfüllen und zum Zweckverband zurückzusenden!
                           </p>
                           <Alert
                               message=""
                               description="
                         Gilt NUR für Bauwasser und Wassergebühren ab Zählereinbau!
                        "
                               type="warning"
                               showIcon
                           />
                       </Col>
                       <Col span={8} style={{padding: "15px"}}>
                           <div style={{height: "155px"}}>
                               <img style={{width: "106px"}} src={fertigstellungImg}/>
                           </div>
                           <h2>
                               3. Fertigstellungsanzeige
                           </h2>
                           <br/>
                           <a href="https://www.rottenburger-gruppe.de/export/download.php?id=355">
                               <Button className={"pull-right"} type={"primary"} >Fertigstellungsanzeige herunterladen</Button>
                           </a>
                           <br/><br/>
                           <p>
                               Vom Eigentümer und Installateur <b>nach abgeschlossener Wasserinstallation</b> auszufüllen und zum Zweckverband zurückzusenden!
                           </p>
                       </Col>
                   </Row>
               </div>
           </div>
        );
    }
};




export default Success;




// WEBPACK FOOTER //
// ./src/containers/success.js